import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=79d6693e&"
import script from "./EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports